/**
 * Salin teks ke clipboard dengan fallback.
 *
 * navigator.clipboard hanya tersedia di "secure context" (HTTPS atau
 * localhost) — hostname kustom lewat HTTP (mis. s.stikes-hi.local di dev)
 * dianggap tidak aman oleh browser sehingga API-nya undefined/menolak,
 * membuat tombol "salin" terlihat gagal tanpa pesan yang jelas. Fallback
 * document.execCommand tetap bekerja di konteks manapun.
 */
export async function copyText(text) {
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // lanjut ke fallback di bawah
    }
  }

  try {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    textarea.style.pointerEvents = "none";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    const success = document.execCommand("copy");
    document.body.removeChild(textarea);
    return success;
  } catch {
    return false;
  }
}
